<template>
  <div>Edit Areas</div>
</template>

<script>
export default {};
</script>